export enum UnitLabels {
    'BYTES' = 'B',
    'KILOBYTES' = 'KB',
    'MEGABYTES' = 'MB',
    'GIGABYTES' = 'GB',
    'PETABYTES' = 'PB'
}
